import { cloneDeep } from "lodash";

import { DiscountTierDto, DiscountUnitType } from "@intelligems/ig-types";

import { DISCOUNT_MAX_UNITS } from "../initials";

export const recalculateUnitQuantities = (
  unitType: DiscountUnitType,
  _tiers: DiscountTierDto[],
  tierIndex: number
) => {
  const tiers = cloneDeep(_tiers);
  for (let i = 0; i < tiers.length; i++) {
    if (i === 0 && tiers.length > 1) {
      tiers[i].maximumUnits =
        tiers[i + 1].minimumUnits - (unitType === "dollar" ? 0.01 : 1);
    }

    if (i > 0 && i > tierIndex) {
      if (tiers[i].minimumUnits <= tiers[i - 1].maximumUnits) {
        tiers[i].minimumUnits =
          tiers[i - 1].maximumUnits + (unitType === "dollar" ? 0.01 : 1);
      }
    }

    if (i > 0 && i < tiers.length - 1) {
      tiers[i].maximumUnits =
        tiers[i + 1].minimumUnits - (unitType === "dollar" ? 0.01 : 1);
    }

    if (tiers[i].maximumUnits < tiers[i].minimumUnits) {
      tiers[i].maximumUnits =
        unitType === "dollar"
          ? tiers[i].minimumUnits + 0.99
          : tiers[i].minimumUnits;
    }

    if (i === tiers.length - 1) {
      tiers[i].maximumUnits = DISCOUNT_MAX_UNITS;
    }
  }
  return tiers;
};

export const resetUnitQuantities = (tiers: DiscountTierDto[]) => {
  return tiers.map((tier, index) => {
    tier.minimumUnits = index;
    if (index === tiers.length - 1) {
      tier.maximumUnits = DISCOUNT_MAX_UNITS;
    } else {
      tier.maximumUnits = index;
    }
    return tier;
  });
};
